const authenticationTypes = {
  MERCURY: 'MERCURY',
  IES_V2: 'AZURE_AD',
};
export default authenticationTypes;
